import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const Testimonial = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Start Hacking!',
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-right" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/MullaAhmed/Truth-or-Dare">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/truth.jpg')}
                      alt="Truth-Or-Dare"
                      width={350}
                      height={350}
                      a href="https://github.com/MullaAhmed/Truth-or-Dare" />
                      <p></p>
                      <b>A Graphic User Interface (GUI) based Truth and Dare game built using Python</b>
                      <p></p>
                      Tech Stack: 
                      Python, Tkinter, Pandas 
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Truth-Or-Dare</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/MullaAhmed/Truth-or-Dare">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/MullaAhmed/RealTime-Face-Detection">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/faceDetection.jpg')}
                      alt="Real-Time face detection"
                      width={300}
                      height={60}
                      a href="https://github.com/MullaAhmed/RealTime-Face-Detection" />
                      <p></p>
                      <b>Real-Time face detection  </b>
                      <p></p>
                      Tech Stack: Python,Django,Tensorflow 
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Real-Time face detection</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/MullaAhmed/RealTime-Face-Detection">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-left" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/harshvarmora28/pioneer">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/pioneer.jpg')}
                      alt="pioneer"
                      width={300}
                      height={60}
                      a href="https://github.com/harshvarmora28/pioneer" />
                      <p></p>
                      <b>A hiring cell which connects university placement cell and companies.  </b>
                      <p></p>
                      Tech Stack: Reactjs, Firebase
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Pioneer</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/harshvarmora28/pioneer">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-right" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/vipulchaudhary16/Vinsta-Social-media-app">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/socialmedia.jpg')}
                      alt="Vinsta-Social-media-app"
                      width={300}
                      height={300}
                      a href="https://github.com/vipulchaudhary16/Vinsta-Social-media-app" />
                      <p></p>
                      <b>An App where user can post photo as a post or story. </b>
                      <p></p>
                      Tech Stack: JAVA, Firebase (Datastore)
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Vinsta-Social-media-app</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/vipulchaudhary16/Vinsta-Social-media-app">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/Priya730/HealthiHer">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/healthiher.jpg')}
                      alt="HealthiHer"
                      width={300}
                      height={300}
                      a href="https://github.com/Priya730/HealthiHer" />
                      <p></p>
                      <b>Women-centric health website providing awareness about women's healthcare with meditation app.</b>
                      <p></p>
                      Tech Stack: HTML CSS JS
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">HealthiHer</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/Priya730/HealthiHer">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-left" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/Priya730/unipass">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/unipass.jpg')}
                      alt="unipass"
                      width={300}
                      height={300}
                      a href="https://github.com/Priya730/unipass" />
                      <p></p>
                      <b>Node.js command-line password generator. Create passwords right in your terminal.</b>
                      <p></p>
                      Tech Stack: Node.js 
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Unipass</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/Priya730/unipass">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-right" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/vipulchaudhary16/Quiz-Website">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/quiz.jpg')}
                      alt="Quiz-Website"
                      width={300}
                      height={300}
                      a href="https://github.com/vipulchaudhary16/Quiz-Website" />
                      <p></p>
                      <b>A Quiz Website where admin will conduct quiz and Student can Attend conducted Quiz</b>
                      <p></p>
                      Tech Stack:HTML, Bootstrap, PHP, MySQL 
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Quiz-Website</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/vipulchaudhary16/Quiz-Website">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/Kunal-Kumar-Sahoo/Apna-Code-Editor">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/code.jpg')}
                      alt="Apna-Code-Editor"
                      width={300}
                      height={300}
                      a href="https://github.com/Kunal-Kumar-Sahoo/Apna-Code-Editor" />
                      <p></p>
                      <b>Code Editor made using Python.</b>
                      <p></p>
                      Tech Stack: Python, Tkinter
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Apna-Code-Editor</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/Kunal-Kumar-Sahoo/Apna-Code-Editor">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-left" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/Kunal-Kumar-Sahoo/SortingVisualizer">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/sorting.png')}
                      alt="SortingVisualizer"
                      width={400}
                      height={400}
                      a href="https://github.com/Kunal-Kumar-Sahoo/SortingVisualizer" />
                      <p></p>
                      <b>Sorting Visualizer made using Python</b>
                      <p></p>
                      Tech Stack: Python
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Sorting Visualizer</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/Kunal-Kumar-Sahoo/SortingVisualizer">GitHub</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-right" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/Kunal-Kumar-Sahoo/Face-Recognition-cum-Attendance">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/attendance.jpg')}
                      alt="Truth-Or-Dare"
                      width={400}
                      height={400}
                      a href="https://github.com/Kunal-Kumar-Sahoo/Face-Recognition-cum-Attendance" />
                      <p></p>
                      <b>Face Recognition system for attendance</b>
                      <p></p>
                      Tech Stack: Python3 (opencv, dlib)
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Face Recognition cum Attendance</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/Kunal-Kumar-Sahoo/Face-Recognition-cum-Attendance">GitHub</a>
                  </span>
                </div>
              </div>
            </div>


            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/Priyanshu9898/Rapid-crew">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/fashion.jpg')}
                      alt="Rapid-crew"
                      width={400}
                      height={400}
                      a href="https://github.com/Priyanshu9898/Rapid-crew" />
                      <p></p>
                      <b>A Fashion Recommendation System</b>
                      <p></p>
                      Tech Stack: Reactjs, Flask
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">Rapid-crew</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/Priyanshu9898/Rapid-crew">GitHub</a>
                  </span>
                </div>
              </div>
            </div>


            <div className="tiles-item reveal-from-left" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div>
                <a href="https://github.com/JayNakum/eXPe">
                  <p className="text-sm mb-0">
                  <Image
                      src={require('./../../assets/images/expense.jpg')}
                      alt="eXPe"
                      width={400}
                      height={400}
                      a href="https://github.com/JayNakum/eXPe" />
                      <p></p>
                      <b>A simple app to keep track of your daily expenses.</b>
                      <p></p>
                      Tech Stack: Flutter, SQLite
                      </p>
                  </a>
                </div>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                  <span className="testimonial-item-name text-color-high">eXPe</span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    <a href="https://github.com/JayNakum/eXPe">GitHub</a>
                  </span>
                </div>
              </div>
              
            </div>
          </div>
            <div>
            <span className="testimonial-item-name text-color-high">For more and past projects visit:</span>
            <span className="testimonial-item-link">
                    <a href="https://github.com/orgs/gdsc-pdeu/repositories"> GitHub/gdsc-pdeu</a>
            </span>
            </div>
        </div>
      </div>
    </section>
  );
}

Testimonial.propTypes = propTypes;
Testimonial.defaultProps = defaultProps;

export default Testimonial;